import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client.ts";
import { keys } from "../api/queryKeys.ts";

/** Master-company filter options (countries, industries, role types, ...), shared by every page. */
export function useFilterOptions({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: keys.masterCompany.filterOptions(),
    queryFn: () => api.getFilterOptions(),
    enabled,
    staleTime: 30 * 60 * 1000,
  });
}
